import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import { FaPaperPlane } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EnquiryForm = ({ title = "Send Us an Enquiry", context = "general" }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    brand_name: '',
    product_type: '',
    quantity: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/enquiries`, formData);
      toast.success('Enquiry submitted successfully! We will contact you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        brand_name: '',
        product_type: '',
        quantity: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      toast.error('Failed to submit enquiry. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100" data-testid="enquiry-form">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-[#0F5132] mb-2">{title}</h3>
        <p className="text-gray-600 text-sm">Fill out the form below and we'll get back to you within 24 hours</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-[#0F5132] mb-2">Full Name *</label>
            <Input
              type="text"
              name="name"
              data-testid="enquiry-name-input"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
              className="w-full"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-[#0F5132] mb-2">Email Address *</label>
            <Input
              type="email"
              name="email"
              data-testid="enquiry-email-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
              className="w-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-[#0F5132] mb-2">Phone Number *</label>
            <Input
              type="tel"
              name="phone"
              data-testid="enquiry-phone-input"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+91 XXXXX XXXXX"
              className="w-full"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-[#0F5132] mb-2">Brand Name (Optional)</label>
            <Input
              type="text"
              name="brand_name"
              data-testid="enquiry-brand-input"
              value={formData.brand_name}
              onChange={handleChange}
              placeholder="Your brand name"
              className="w-full"
            />
          </div>
        </div>

        {context === 'manufacturing' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-[#0F5132] mb-2">Product Type</label>
              <select
                name="product_type"
                data-testid="enquiry-product-type-select"
                value={formData.product_type}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0F5132] focus:border-transparent"
              >
                <option value="">Select Product Type</option>
                <option value="Syrup">Syrup</option>
                <option value="Tablet">Tablet</option>
                <option value="Capsule">Capsule</option>
                <option value="Powder">Powder</option>
                <option value="Oil">Oil</option>
                <option value="Juice">Juice</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-[#0F5132] mb-2">Quantity Required</label>
              <Input
                type="text"
                name="quantity"
                data-testid="enquiry-quantity-input"
                value={formData.quantity}
                onChange={handleChange}
                placeholder="e.g., 5000 pieces"
                className="w-full"
              />
            </div>
          </div>
        )}

        <div>
          <label className="block text-sm font-medium text-[#0F5132] mb-2">Message *</label>
          <Textarea
            name="message"
            data-testid="enquiry-message-textarea"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Tell us about your requirements..."
            rows={4}
            className="w-full"
          />
        </div>

        <Button
          type="submit"
          data-testid="enquiry-submit-button"
          disabled={isSubmitting}
          className="w-full bg-[#0F5132] hover:bg-[#0D4228] text-white py-6 text-lg font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
        >
          {isSubmitting ? (
            <span>Submitting...</span>
          ) : (
            <span className="flex items-center justify-center space-x-2">
              <FaPaperPlane />
              <span>Submit Enquiry</span>
            </span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default EnquiryForm;